import { render } from "./comHttpPolling.vue?vue&type=template&id=c1912200"
import script from "./comHttpPolling.vue?vue&type=script&lang=js"
export * from "./comHttpPolling.vue?vue&type=script&lang=js"

import "./comHttpPolling.vue?vue&type=style&index=0&id=c1912200&lang=css"

import exportComponent from "D:\\00project\\36live\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__